export default function Home() {
  return <div>Login gateway for web3</div>;
}
